/**
 * IconsConfig.js
 *
 * Composition root for icon system wiring.
 *
 * - Manifest source: icons/IconManifest.js (window.TMS_ICON_MANIFEST)
 * - Facade engine: icons/IconFacade.js (window.TMS_IconFacade)
 * - Active adapter: icons/adapters/FontAwesomeAdapter.js (window.TMS_FontAwesomeAdapter)
 */
(function (global) {
	'use strict';

	var manifest = global.TMS_ICON_MANIFEST || {};
	var defaults = {
		confirmYes: 'check',
		confirmCancel: 'close',
		actionSave: 'save',
		actionClose: 'close',
		actionEdit: 'edit',
		actionDelete: 'trash',
		actionAdd: 'add',
		statusInfo: 'info',
		statusWarning: 'warning',
		statusError: 'error',
		statusSuccess: 'success',
		navNext: 'next',
		navPrev: 'prev',
		actionRefresh: 'refresh',
		fallback: 'help'
	};

	Object.keys(defaults).forEach(function (key) {
		if (!Object.prototype.hasOwnProperty.call(manifest, key)) {
			manifest[key] = defaults[key];
		}
	});

	if (!global.TMS_IconFacade || !global.TMS_FontAwesomeAdapter) {
		// Keep a minimal safe object if dependencies are missing.
		global.TMS_ICONS = {
			manifest: manifest,
			/**
			 * Fallback canonical resolver used only when facade dependencies are unavailable.
			 */
			getCanonicalToken: function (keyOrToken) { return manifest[keyOrToken] || keyOrToken || manifest.fallback; },
			/**
			 * Backward-compatible alias to token resolution in degraded mode.
			 */
			getFaToken: function (keyOrToken) { return manifest[keyOrToken] || keyOrToken || manifest.fallback; },
			/**
			 * Class rendering is disabled in degraded mode because no adapter is available.
			 */
			getClass: function () { return ''; },
			/**
			 * Returns token for legacy paths in degraded mode.
			 */
			getLegacyToken: function (keyOrToken) { return manifest[keyOrToken] || keyOrToken || manifest.fallback; },
			/**
			 * HTML rendering is disabled in degraded mode because no adapter is available.
			 */
			renderI: function () { return ''; }
		};
		return;
	}

	var api = global.TMS_IconFacade.create({
		manifest: manifest,
		defaultAdapter: 'fontawesome'
	});

	api.registerAdapter('fontawesome', global.TMS_FontAwesomeAdapter);

	// Backward-compatible naming for existing usage introduced in earlier revision.
	/**
	 * Alias maintained for backward compatibility with earlier API naming.
	 */
	api.getFaToken = function (keyOrToken, opt) {
		return api.getToken(keyOrToken, opt);
	};

	// Preserve direct property access for semantic keys where convenient.
	Object.keys(manifest).forEach(function (key) {
		api[key] = api.getLegacyToken(key);
	});

	global.TMS_ICONS = api;
})(typeof window !== 'undefined' ? window : this);
